import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';


const NewParticipantIO = t.interface({
    id: t.string,
    name: t.string,
});

export type NewParticipant = t.TypeOf<typeof NewParticipantIO>;
export const isNewParticipant = createGuard(NewParticipantIO);


interface NewParticipantSuccessResponseType {
    status: 'success',
    value: NewParticipant
}

interface NewParticipantErrorResponseType {
    status: 'error'
    message: string
}

export type NewParticipantResponseType = NewParticipantSuccessResponseType | NewParticipantErrorResponseType;
